import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.header
      className={`fixed top-0 w-full z-50 transition-all duration-500 ${
        isScrolled ? 'bg-[#0a0a0b]/90 backdrop-blur-xl border-b border-white/5' : 'bg-transparent'
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="container mx-auto px-6 py-5 flex items-center justify-between">
        <Link to="/">
          <img src="/logo.png" alt="Invarya" className="h-8 brightness-0 invert" />
        </Link>

        <nav className="hidden md:flex items-center space-x-8">
          <Link
            to="/work"
            className={`text-sm transition-colors ${location.pathname === '/work' ? 'text-white' : 'text-gray-300 hover:text-white'}`}
          >
            Our Work
          </Link>
          <Link
            to="/contact"
            className={`text-sm transition-colors ${location.pathname === '/contact' ? 'text-white' : 'text-gray-300 hover:text-white'}`}
          >
            Contact Us
          </Link>
          <a href="/#about" className="text-sm text-gray-300 hover:text-white transition-colors">About</a>
          <Button
            className="bg-white text-black hover:bg-gray-200 transition-all duration-300"
            onClick={() => window.dispatchEvent(new CustomEvent('open-chat-widget'))}
          >
            Talk to an Expert
          </Button>
        </nav>
      </div>
    </motion.header>
  );
};

export default Header;
